export default [
  {
    path: "/qspiQIP",
    name: "QIP",
    component: () => import("@/components/page/QSPI/QIP/index"),
    meta: { title: "QIP" },
  },
  {
    path: "/qspiQIP/detail",
    name: "QIPDetail",
    component: () => import("@/components/page/QSPI/QIP/detail"),
    meta: { title: "QIP 维护" },
  },
];
